import {
  edgeLocationDrawerKey,
  edgeLocationProviderKey,
  edgeLocationProviderProjectIdKey,
  edgeLocationRegionKey,
} from './edge-locations/constants';
import { EdgeLocationInitialData } from './edge-locations/types';

type MakeEdgeLocationDrawerLinkArgs = {
  clusterId: string;
  queryParams?: EdgeLocationInitialData;
};

export const makeEdgeLocationDrawerLink = ({
  clusterId,
  queryParams,
}: MakeEdgeLocationDrawerLinkArgs): string => {
  const basePath = `/automation/external-clusters/${clusterId}/autoscaler/settings/edge-locations`;

  const searchParams = new URLSearchParams();
  searchParams.set(edgeLocationDrawerKey, 'true');
  if (queryParams?.provider) {
    searchParams.set(edgeLocationProviderKey, queryParams.provider);
  }
  if (queryParams?.region) {
    searchParams.set(edgeLocationRegionKey, queryParams.region);
  }
  if (queryParams?.providerProjectId) {
    searchParams.set(
      edgeLocationProviderProjectIdKey,
      queryParams.providerProjectId
    );
  }

  return `${basePath}?${searchParams.toString()}`;
};
